export default "__VITE_ASSET__23197670__"